import { useEffect, useState } from 'react'
import styled from 'styled-components'
import { useGetChart, useGetGroupListOrderAware, UseGetTaskChart } from './utils'
import ReactECharts from 'echarts-for-react'
import { TableTag } from '@/components'
import { Empty, Select, Typography } from 'antd'
import EmptyImg from '@/assets/imges/Empty/EmptyLine.png'
import Emptygauge from '@/assets/imges/Empty/empty-gauge.png'
import { t } from '@/i18n'

const CompanyScore = props => {
  const [getChart] = useGetChart()
  const [getGroupListOrderAware, loading] = useGetGroupListOrderAware()
  const [getTaskChart] = UseGetTaskChart()
  let [current, setCurrent] = useState()
  let [buList, setBuList] = useState([])
  let [scoreList, setScoreList] = useState([])
  let [timeList, setTimeList] = useState([])
  let [score, setScore] = useState(0)
  let [aware, setAware] = useState(0)
  let [hasTask, setHasTask] = useState(false)
  const handleGetLeftList = async () => {
    try {
      const res = await getChart()
      setHasTask(res.data?.has_task !== 2)
      setScore((score = res.data?.company_score || 0))
      setAware(
        (aware = res.data?.count || [
          { name: t('优秀'), value: 0 },
          { name: t('良好'), value: 0 },
          { name: t('较差'), value: 0 },
          { name: t('差'), value: 0 },
        ]),
      )
    } catch (error) {}
  }
  const handleGetRightList = async () => {
    try {
      const res = await getGroupListOrderAware()
      console.log('bulist:', res.data.items)
      setBuList((buList = res.data.items))
      setCurrent(buList[0]?.id)
    } catch (error) {}
  }
  const handleGetTaskChart = async () => {
    try {
      if (current) {
        const res = await getTaskChart({ group_id: current })
        setScoreList(res.data?.score_list)
        setTimeList(res.data?.time_list)
      }
    } catch (error) {}
  }
  useEffect(() => {
    handleGetLeftList()
    handleGetRightList()
  }, [])
  useEffect(() => {
    handleGetTaskChart()
  }, [current])
  useEffect(() => {
    console.log('buList', buList)
  }, [buList])

  const option1 = (values: { value: number; title: string }) => {
    const { value, title } = values
    return {
      series: [
        {
          type: 'gauge',
          min: 0,
          max: 100,
          splitNumber: 5,
          radius: '80%',
          center: ['50%', '65%'],
          // radius: ['40%', '60%'],
          axisLine: {
            lineStyle: {
              width: 10,
              color: [
                [0.39, '#FF5151'],
                [0.59, '#FFB035'],
                [0.79, '#739DFF'],
                [1, '#7FB663'],
              ],
            },
          },
          pointer: {
            icon: 'path://M12.8,0.7l12,40.1H0.7L12.8,0.7z',
            length: '15%',
            width: 10,
            offsetCenter: [0, -45],
            itemStyle: {
              color: 'auto',
            },
          },
          axisTick: {
            length: 5,
            lineStyle: {
              color: 'auto',
              width: 1,
            },
            distance: 3,
          },
          splitLine: {
            length: 7,
            distance: 2,
            lineStyle: {
              color: 'auto',
              width: 2,
            },
          },
          axisLabel: {
            color: '#666666',
            fontSize: 8,
            distance: 15,
          },
          title: {
            offsetCenter: [0, -20],
            fontSize: 16,
          },
          detail: {
            fontSize: 20,
            offsetCenter: [0, 10],
            valueAnimation: true,
            formatter: function (num) {
              return `${Math.round(num)}`
            },
            color: 'auto',
          },
          data: [
            {
              value: value,
              name: title,
            },
          ],
        },
      ],
    }
  }
  const option2 = {
    title: {
      text: t('部门安全意识'),
      subtext: t('等级分布'),
      left: 'center',
      top: '40%',
      textStyle: {
        color: '#666666',
        fontSize: 14,
        fontWeight: 400,
        align: 'center',
      },
      subtextStyle: {
        color: '#333',
        fontSize: 18,
        fontWeight: 500,
      },
    },
    tooltip: {
      trigger: 'item',
    },
    legend: {
      bottom: '5%',
      left: 'center',
    },
    series: [
      {
        name: hasTask ? t('安全意识') : '',
        type: 'pie',
        top: '15%',
        radius: ['55%', '80%'],
        center: ['50%', '37%'],
        avoidLabelOverlap: false,
        label: {
          formatter: '{b}:{c}' + '\n\r' + '({d}%)',
          show: false,
          position: 'center',
        },
        itemStyle: {
          normal: {
            color: function (colors) {
              let colorList = ['#7FB663', '#739DFF', '#FFB035', '#FF5151']
              return colorList[colors.dataIndex]
            },
          },
        },
        labelLine: {
          show: false,
        },
        data: hasTask ? aware : [],
      },
    ],
  }
  const option3 = {
    tooltip: {
      trigger: 'axis',
      axisPointer: {
        type: 'cross',
        crossStyle: {
          color: '#999',
        },
      },
    },
    grid: {
      left: '2%',
      right: '5%',
      bottom: '2%',
      containLabel: true,
    },
    xAxis: [
      {
        type: 'category',
        data: timeList,
        axisPointer: {
          type: 'shadow',
        },
      },
    ],

    yAxis: [
      {
        type: 'value',
        name: t('分'),
        min: 0,
        max: 100,
        interval: 20,
        nameTextStyle: {
          align: 'right',
        },
      },
    ],

    series: [
      {
        name: t('部门评分'),
        type: 'line',
        data: scoreList,
      },
    ],
  }
  const BuItem = prop => {
    // eslint-disable-next-line @typescript-eslint/naming-convention
    const { id, name, task_level } = prop
    return (
      <BuItemStyle
        onClick={() => {
          setCurrent((current = id))
        }}
        isActive={current === id}
      >
        <Typography.Text
          className="bu-item-name"
          ellipsis={{
            tooltip: { placement: 'top', getPopupContainer: () => document.body },
          }}
        >
          {name}
        </Typography.Text>
        <div style={{ width: 36 }}>
          {task_level === '优秀' && (
            <TableTag background="#D6F4C7" color="#5BC825">
              {task_level}
            </TableTag>
          )}
          {task_level === '良好' && (
            <TableTag background="#E2E4FF" color="#2973FF">
              {task_level}
            </TableTag>
          )}
          {task_level === '较差' && (
            <TableTag background="#FFEBB4" color="#FFA709">
              {task_level}
            </TableTag>
          )}
          {task_level === '差' && (
            <TableTag background="#FFC9C9" color="#FF2929">
              {task_level}
            </TableTag>
          )}
        </div>
      </BuItemStyle>
    )
  }

  const renderLever = (task_level?: string) => {
    switch (task_level) {
      case '优秀':
        return (
          <TableTag background="#D6F4C7" color="#5BC825" style={{ padding: '2px 6px' }}>
            {task_level}
          </TableTag>
        )

      case '良好':
        return (
          <TableTag background="#E2E4FF" color="#2973FF" style={{ padding: '2px 6px' }}>
            {task_level}
          </TableTag>
        )

      case '较差':
        return (
          <TableTag background="#FFEBB4" color="#FFA709" style={{ padding: '2px 6px' }}>
            {task_level}
          </TableTag>
        )

      case '差':
        return (
          <TableTag background="#FFC9C9" color="#FF2929" style={{ padding: '2px 6px' }}>
            {task_level}
          </TableTag>
        )

      default:
        return null
      // <TableTag background="#D9D9D9" color="#666666" style={{ padding: '2px 6px' }}>
      //   {'未评估'}
      // </TableTag>
    }
  }

  return (
    <Container>
      <div className="score-container">
        <div className="score-title">{t('安全意识评分')}</div>
        <ContainerScore>
          <div className="score">
            {hasTask ? (
              <>
                <div className="score-charts">
                  <ReactECharts
                    // style={{ width: '210px', height: '210px' }}
                    option={option1({
                      value: score,
                      title:
                        (score <= 100 && score >= 80 && t('优秀')) ||
                        (score < 80 && score >= 60 && t('良好')) ||
                        (score < 60 && score >= 40 && t('较差')) ||
                        (score < 40 && t('差')),
                    })}
                  />
                </div>
                <Typography.Text
                  className="tag"
                  ellipsis={{
                    tooltip: { placement: 'top', getPopupContainer: () => document.body },
                  }}
                >
                  {props.name}
                </Typography.Text>
              </>
            ) : (
              <Empty image={Emptygauge} imageStyle={{ height: 190 }} />
            )}
          </div>
          <div className="level">
            <div className="level-charts">
              <ReactECharts
                // style={{ height: ' 360px', width: '360px' }}
                option={option2}
              />
            </div>
          </div>
        </ContainerScore>
      </div>
      <ContainerTrend>
        <div
          className="title"
          style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            marginBottom: 20,
          }}
        >
          {t('近十次部门安全意识测评趋势')}

          <Select
            style={{ width: 200 }}
            value={current}
            onChange={value => {
              setCurrent(value)
            }}
            options={buList.map((it: any) => ({
              value: it.id,
              label: (
                <div style={{ display: 'flex', alignItems: 'center' }}>
                  <span
                    style={{
                      display: 'inline-block',
                      maxWidth: 120,
                      whiteSpace: 'nowrap',
                      textOverflow: 'ellipsis',
                      overflow: 'hidden',
                      marginRight: 4,
                    }}
                    title={it.name}
                  >
                    {`${it.name}`}
                  </span>
                  {renderLever(it.task_level)}
                </div>
              ),
            }))}
          />
        </div>
        <div className="content">
          {buList.length > 0 ? (
            <>
              {/* <BuContainer>
               {buList.map(item => (
                 <BuItem key={item?.id} {...item} />
               ))}
              </BuContainer> */}
              {scoreList.length > 0 ? (
                <div className="charts">
                  <ReactECharts option={option3} />
                </div>
              ) : (
                <div
                  style={{
                    height: 'calc(100% - 100px)',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                  }}
                >
                  <Empty image={EmptyImg} />
                </div>
              )}
            </>
          ) : (
            <Empty image={EmptyImg} />
          )}
        </div>
      </ContainerTrend>
    </Container>
  )
}

const Container = styled.div`
  margin-bottom: 8px;
  display: flex;
  .score-container {
    width: 50%;
  }
  .score-title {
    width: 90px;
    font-size: 14px;
    font-family: SourceHanSansCN-Normal, SourceHanSansCN;
    font-weight: 600;
    color: #333333;
    line-height: 21px;
    margin-bottom: 30px;
  }
`
const ContainerScore = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  flex-wrap: wrap;
  .level {
    width: 50%;
    position: relative;
    top: 30px;
  }
  .score {
    width: 50%;
    /* margin-left: 40px; */
    display: flex;
    flex-direction: column;
    align-items: center;
  }
  .score-charts {
    width: 100%;
  }
  .level-charts {
    width: 100%;
  }
  .charts {
    display: flex;
  }
  .tag {
    text-align: center;
    width: 160px;
    height: 24px;
    background: rgba(127, 182, 99, 0.1);
    border-radius: 4px;
    border: 1px solid #a3cb8f;
    font-size: 12px;
    font-family: SourceHanSansCN-Normal, SourceHanSansCN;
    font-weight: 400;
    color: #7fb563;
    line-height: 22px;
    overflow: hidden;
  }
`
const ContainerTrend = styled.div`
  display: flex;
  flex-direction: column;
  width: 50%;
  .title {
    font-size: 14px;
    font-family: SourceHanSansCN-Normal, SourceHanSansCN;
    font-weight: 600;
    color: #333333;
    margin-bottom: 30px;
  }
  .content {
    /* flex: 1; */
    margin-top: 0;
    width: 100%;
    height: 320px;
    border-radius: 8px;
    border: 1px solid #d9d9d9;
    padding-top: 5px;
    .charts {
      /* height: 100%; */
      /* z-index: 1;
      top: -24px;
      position: relative; */
    }
  }
`
const BuContainer = styled.div`
  margin: 6px;
  height: 44px;
  display: grid;
  justify-content: space-between;
  grid-template-columns: repeat(auto-fill, minmax(120px, 1fr));
  justify-items: center;
  overflow-y: auto;
`
interface BuItemStyleProps {
  isActive: boolean
}
const BuItemStyle = styled.div<BuItemStyleProps>`
  cursor: pointer;
  z-index: 10;
  width: 120px;
  height: 44px;
  background: #f7f8f9;
  border-radius: 6px;
  display: flex;
  align-items: center;
  font-size: 12px;
  font-family: SourceHanSansCN-Normal, SourceHanSansCN;
  font-weight: 400;
  color: #333333;
  justify-content: center;
  gap: 4px;
  border: 2px solid ${props => (props.isActive ? '#a8a8d7' : 'none')};
  .bu-item-name {
    width: 60px;
    /* text-align: center; */
  }
`

export default CompanyScore
